// extracted by mini-css-extract-plugin
module.exports = {"modal-text":"NewBudgetAllocation_modal-text__gpOrf","modal-input__title":"NewBudgetAllocation_modal-input__title__3LK6q","modal-button":"NewBudgetAllocation_modal-button__1KdiD"};